'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackPageView = exports.error = exports.warn = exports.info = exports.debug = exports.trace = exports.types = exports.levels = exports.configureLoggers = undefined;

var _config = require('./config');

Object.defineProperty(exports, 'configureLoggers', {
  enumerable: true,
  get: function get() {
    return _config.configureLoggers;
  }
});

var _logLevelConstants = require('./log-level-constants');

Object.defineProperty(exports, 'levels', {
  enumerable: true,
  get: function get() {
    return _logLevelConstants.levels;
  }
});

var _logTypesConstants = require('./log-types-constants');

Object.defineProperty(exports, 'types', {
  enumerable: true,
  get: function get() {
    return _logTypesConstants.types;
  }
});


var write = function write() {
  var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _logLevelConstants.INFO;

  try {
    _config.loggers.forEach(function (logger) {
      if (!logger.write) {
        throw new Error("Logger doesn't have a write function defined");
      }
      var successfullWrite = void 0;

      if (level < logger.minimumLogLevel) {
        // skip the actual writing because minimum level is too low
        successfullWrite = true;
      } else {
        var message = properties.message;
        // if there is a function passed, execute the fn to get the underlying msg

        if (typeof message === 'function') {
          properties.message = message();
        }
        // append level to properties
        successfullWrite = logger.write(Object.assign({}, properties, { level: level }));
      }

      if (!successfullWrite) {
        // eslint-disable-next-line no-console
        console.error('Could not complete log');
      }
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
};

var trace = exports.trace = function trace(properties) {
  return write(properties, _logLevelConstants.TRACE);
};

var debug = exports.debug = function debug(properties) {
  return write(properties, _logLevelConstants.DEBUG);
};

var info = exports.info = function info(properties) {
  return write(properties, _logLevelConstants.INFO);
};

var warn = exports.warn = function warn(properties) {
  return write(properties, _logLevelConstants.WARN);
};

var error = exports.error = function error(properties) {
  return write(properties, _logLevelConstants.ERROR);
};

var trackPageView = exports.trackPageView = function trackPageView(properties) {
  return _config.loggers.forEach(function (logger) {
    return logger.trackPageView(properties);
  });
};